<template>
	<van-sticky>
		<div class="tool-bar">
			<span>已选择（<strong>{{ checkNum }}</strong>）项</span>
			<van-button round type="danger" size="mini" @click="delSelected">删除所选</van-button>
		</div>
	</van-sticky>
	<div class="shop-cart">
		<div class="box" v-for="(item, index) in list" :key="index">
			<div class="header">
				<van-checkbox v-model="selectAllVendor[index]" @click="toggleAllVendor(index)">
					<van-icon name="shop-o"/>
				</van-checkbox>
				<span>{{ item.vendorName }}</span>
			</div>
			<van-checkbox-group v-model="checkedIds[index]" :ref="el => checkboxGroupRefs[index] = el">
				<van-cell-group :border="false">
					<van-cell
							v-for="(book, idx) in item.books"
							clickable
							:key="idx"
					>
						<template #icon>
							<van-checkbox
									:name="book.id"
									@click.stop
							/>
						</template>
						<template #title>
							<div class="book-item" v-if="book.pdaBook">
								<div class="cover">
									<img v-if="book.pdaBook.coverUrl" :src="book.pdaBook.coverUrl" :key="book.pdaBook.bookId" @error="handleErrorImage($event)"/>
									<img v-else :src="defaultCover()" :key="book.pdaBook.bookId"/>
								</div>
								<div class="right">
									<router-link class="title" :to="'/orderBookDetail/' + book.pdaBook.bookId">{{
											book.pdaBook.title
										}}
									</router-link>
									<p>{{ book.pdaBook.author }}</p>
									<p>{{ book.pdaBook.publisher+'/'+  book.pdaBook.publicationDate}}</p>
									<p>
										<span class="price">￥{{ book.pdaBook.price }}</span>
<!--										<span class="stock">库存:{{ book.pdaBook.inventory }}</span>-->
									</p>
								</div>
							</div>
						</template>
					</van-cell>
				</van-cell-group>
			</van-checkbox-group>
		</div>
	</div>
	<van-submit-bar :price="allPrice * 100" :decimal-length="1" button-text="提交订单" @submit="onSubmit">
		<van-checkbox v-model="selectAll" @click="toggleAll">全选</van-checkbox>
	</van-submit-bar>
</template>

<script>
import {
	defineComponent,
	ref,
	onMounted,
	watch
} from 'vue';
import {Toast, Dialog} from 'vant';
import {getCarts, getCartNum, getConsignee} from '@/api/users';
import {isNotEmpty, randomBookCover, setCoversCart} from '@/utils/util';
import {delCart} from '@/api/carts';
import store from '@/store';
import {useRouter} from "vue-router";

export default defineComponent({
	name: "ShopCart",
	setup() {
		const router = useRouter();
		// 各个供应商选择组件
		const checkboxGroupRefs = ref([]);
		// 当前选中图书的id  二维数组
		const checkedIds = ref([]);
		// 供应商是否全选 数组
		const selectAllVendor = ref([]);
		// 是否全选
		const selectAll = ref(false);
		// 购物车数据  {vendorName:string,books:[]}
		const list = ref([]);
		// 已选择数量
		const checkNum = ref(0);
		// 所有书本数量
		let total = 0;
		// 合计的价格
		const allPrice = ref(0);
		// 获取购物车数据
		const onGetCarts = () => {
			list.value = [];
			total = 0;
			allPrice.value = 0;
			getCarts()
					.then(data => {
						// 返回一个Map<string,list>  key是供应商名称 value是列表
						if (isNotEmpty(data)) {
							const isbns = [];
							const data1 = [];
							for (let key in data) {
								data1.push({vendorName: key, books: data[key]});
								data[key].forEach(item => {
									total++;
									if (isNotEmpty(item.pdaBook)) {
										isbns.push(item.pdaBook.isbn);
									}
								})
							}
							if (isNotEmpty(isbns)) {
								setCoversCart(isbns, data1);
							}
							data1.forEach((item, index) => {
								checkedIds.value[index] = [];
								selectAllVendor.value[index] = false;
							});
							list.value = data1;
						} else {
							list.value = [];
							checkedIds.value = [];
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		onMounted(() => {
			onGetCarts();
		});
		// 供应商全选
		const toggleAllVendor = (index) => {
			selectAllVendor.value[index] = selectAllVendor.value[index];
			checkboxGroupRefs.value[index].toggleAll(selectAllVendor.value[index]);
		};
		// 全选
		const toggleAll = () => {
			checkboxGroupRefs.value.forEach((el, index) => {
				el.toggleAll(selectAll.value);
				selectAllVendor.value[index] = selectAll.value;
			});
		};
		// 删除所选
		const delSelected = () => {
			// 是否选择了数据
			const flag = checkedIds.value.some(ids => isNotEmpty(ids));
			if (flag) {
				Dialog.confirm({
					title: '确认删除所选数据？',
				})
						.then(() => {
							let param = new URLSearchParams()
							checkedIds.value.forEach(item => {
								item.forEach(id => param.append('cartIds[]', id))
							});
							delCart(param)
									.then(data => {
										if (data === null) {
											onGetCarts();
											onCartNum();
											checkNum.value = 0;
											checkedIds.value = [];
											Toast({message: '删除成功'});
										}
									})
									.catch((error) => {
										console.error(error);
									});
						})
						.catch(() => {
						});
			} else {
				Toast({message: '请先选择数据'});
			}
		};
		// 提交订单
		const onSubmit = () => {
			// 是否选择了数据
			const flag = checkedIds.value.some(ids => isNotEmpty(ids));
			if (flag) {
				// 判断是否有默认地址
				onConsignee();
			} else {
				Toast({message: '请先选择数据'});
			}
		};
		// 获取优先收货地址
		const onConsignee = () => {
			getConsignee()
					.then(data => {
						if (isNotEmpty(data)) {
							// 是否有库存
							onInventory();
						} else {
							Dialog.confirm({
                title: '用户暂无收货地址,去设置',
              })
                  .then(() => {
                    router.push({path: '/receivingAddressEdit'});
                  })
                  .catch(() => {
                  });
						}
					})
					.catch((error) => {
						console.error(error);
            Dialog.confirm({
              title: '用户暂无收货地址,去设置',
            })
                .then(() => {
                  router.push({path: '/receivingAddressEdit'});
                })
                .catch(() => {
                });
					});
		};
		// 是否有库存
		const onInventory = () => {
			const flag = checkedIds.value.some((ids, index) => {
				let flag1 = false;
				for (let i = 0; i < ids.length; i++) {
					let id = ids[i];
					const book = list.value[index].books.find(iBook => iBook.id === id);
					if (book && book.pdaBook.inventory === 0) {
						flag1 = true;
						break;
					}
				}
				return flag1;
			})
			if (flag) {
				Toast({message: '所选数据中存在库存为0的图书'});
			} else {
				let params = [];
				checkedIds.value.forEach(item => item.forEach(id => params.push(id)));
				router.push({path: '/shopOrderDetail', query: {ids: params}});
			}
		};
		// 获取购物车数量
		const onCartNum = () => {
			getCartNum()
					.then(data => {
						store.commit('setCartNum', data);
					})
					.catch((error) => {
						console.error(error);
					});
		};
		function handleErrorImage(event){
			event.srcElement.src = randomBookCover();
		}
		function defaultCover(){
			return randomBookCover();
		}
		watch(
				checkedIds, () => {
					// 各供应商的全选状态
					checkedIds.value.forEach((ids, index) => selectAllVendor.value[index] = ids.length === list.value[index].books.length);
					// 是否选择了数据  全选状态 选择项 总计价格
					const flag = checkedIds.value.some(ids => isNotEmpty(ids));
					if (flag) {
						allPrice.value = 0;
						checkNum.value = 0;
						checkedIds.value.forEach((ids, index) => {
							checkNum.value += ids.length;
							ids.forEach(id => {
								const book = list.value[index].books.find(iBook => iBook.id === id);
								if (book) {
									allPrice.value += book.pdaBook.price;
								}
							})
						})
						allPrice.value = allPrice.value.toFixed(1);
						selectAll.value = checkNum.value === total;
					} else {
						selectAll.value = false;
						allPrice.value = 0;
						checkNum.value = 0;
					}
				},
				{immediate: true, deep: true}
		);
		return {
			checkNum,
			allPrice,
			checkboxGroupRefs,
			checkedIds,
			selectAllVendor,
			onGetCarts,
			list,
			toggleAllVendor,
			toggleAll,
			delSelected,
			onSubmit,
			selectAll,
			handleErrorImage,
			defaultCover
		};
	},
});
</script>

<style scoped lang="less">
@import "../assets/css/box.less";
@import "../assets/css/book.less";
@import "../assets/css/shop-cart.less";
</style>
